import React from "react";
import { DefaultButton, Stack, Text } from "@fluentui/react";

interface AdminPaginationProps {
  page: number;
  pageSize: number;
  total: number;
  loading: boolean;
  onPageChange: (page: number) => void;
}

export const AdminPagination: React.FunctionComponent<AdminPaginationProps> = ({
  page,
  pageSize,
  total,
  loading,
  onPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const canGoPrevious = page > 1;
  const canGoNext = page < totalPages;

  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center"
      styles={{ root: { marginTop: 16 } }}
    >
      <Text styles={{ root: { color: "#666" } }}>
        Page {page} of {totalPages} ({total} total)
      </Text>
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <DefaultButton
          text="Previous"
          disabled={loading || !canGoPrevious}
          onClick={() => onPageChange(page - 1)}
        />
        <DefaultButton
          text="Next"
          disabled={loading || !canGoNext}
          onClick={() => onPageChange(page + 1)}
        />
      </Stack>
    </Stack>
  );
};
